/**
 * `status` on the in-app AI's create_task / update_task (04.10.2026, parity
 * with MCP's board tools, card a1b87390).
 *
 * The Task Manager has To do · In progress · Done · Dismissed (card ef074711),
 * but the assistant could only flip `done` — it could not say "I am working on
 * this" and a dismissed task read as done. Same rules as MCP: a status is
 * written with the `done` it implies (`statusPatch`), a `done` that contradicts
 * it is refused and nothing is written, and `done` alone keeps its old meaning
 * (`taskStatusOf` reconciles on read).
 */
import { TASK_STATUSES, statusPatch } from '../../extensions/bundled/task-manager/taskStatus';

/** `{ patch }` to merge into the task, or `{ error }`. */
export function taskStatusInput({ status, done } = {}) {
  if (status == null || status === '') {
    return { patch: done != null ? { done: !!done } : {} };
  }
  if (!TASK_STATUSES.includes(status)) {
    return { error: `status must be one of: ${TASK_STATUSES.join(', ')}` };
  }
  const patch = statusPatch(status);
  if (done != null && !!done !== patch.done) {
    return { error: `done: ${!!done} contradicts status "${status}" — send status alone` };
  }
  return { patch };
}
